import API from "./urls";
import IHttpResponse from "src/http/http-response";
import HttpClient from "src/http/http-client";
import IHttpRequest from "src/http/http-request";

/**
 * 发送ajax请求
 * @param {any} options 请求参数
 * @param {string} url 请求地址
 * @param {string} method 请求类型
 * @returns {any}
 */
const send = (url: string, options?: IHttpRequest, method: any = "post"): IHttpResponse =>
{
    // 如果未传入url以及参数抛出异常
    if (!url)
    {
        throw new Error("url is null.");
    }

    // 返回promise实例由用户处理
    return HttpClient.instance[method](
    {
        url,
        ...options
    });
};

/**
 * 接口类
 * @version 1.0.0
 */
export default class Apis
{
    // 登录授权相关服务
    public login = (option?: IHttpRequest) => send(API.login, option);
    public sendSms = (option?: IHttpRequest) => send(API.sendSms, option);
    public register = (option?: IHttpRequest) => send(API.register, option);
    public updatePassword = (option?: IHttpRequest) => send(API.updatePassword, option);
    public getTaskInfo = (option?: IHttpRequest) => send(API.getTaskInfo, option, "get");
    public getMembers = (option?: IHttpRequest) => send(API.getMembers, option, "get");
    public getQuestionnaireTaskPage = (option?: IHttpRequest) => send(API.getQuestionnaireTaskPage, option);
    public getPhysicalTaskPage = (option?: IHttpRequest) => send(API.getPhysicalTaskPage, option);
    
    public getQuestionnaireList = (option?: IHttpRequest) => send(API.getQuestionnaireList, option, "get");
    public getPhysicalList = (option?: IHttpRequest) => send(API.getPhysicalList, option);
    public getMemberList = (option?: IHttpRequest) => send(API.getMemberList, option);
    public getphysicalDetail = (option?: IHttpRequest) => send(API.getphysicalDetail, option, "get");
    public cancelReserve = (option?: IHttpRequest) => send(API.cancelReserve, option, "put");
    public getSchedules = (option?: IHttpRequest) => send(API.getSchedules, option);
    public changeReserve = (option?: IHttpRequest) => send(API.changeReserve, option);
    public getPackageHospitals = (option?: IHttpRequest) => send(API.getPackageHospitals, option);
    public reservePackage = (option?: IHttpRequest) => send(API.reservePackage, option);
    public validateVacation = (option?: IHttpRequest) => send(API.validateVacation, option,"get");
    // 城市
    public locationCity = (option?: IHttpRequest) => send(API.locationCity, option, "get");
    public getUserSig = (option?: IHttpRequest) => send(API.getUserSig, option, "get");
    public getUserQueueNum = (option?: IHttpRequest) => send(API.getUserQueueNum, option, "get");
    public isBusy = (option?: IHttpRequest) => send(API.isBusy, option, "get");
    public checkState = (option?: IHttpRequest) => send(API.checkState, option, "get");
    public questionnaireTaskSign = (option?: IHttpRequest) => send(API.questionnaireTaskSign, option);
    public reportList = (option?: IHttpRequest) => send(API.reportList, option,"get");
    public reportDetail = (option?: IHttpRequest) => send(API.reportDetail, option,"get");
    public faceVerifyLogin = (option?: IHttpRequest) => send(API.faceVerifyLogin, option);
    public selectFaceVerify = (option?: IHttpRequest) => send(API.selectFaceVerify, option,"get");
    public questionnaireTaskCalling = (option?: IHttpRequest) => send(API.questionnaireTaskCalling, option,"get");
    public getVideoPhoth = (option?: IHttpRequest) => send(API.getVideoPhoth, option,"get");
    public refreshAuth = (option?: IHttpRequest) => send(API.refreshAuth, option,"get");
    public addTrtcLog = (option?: IHttpRequest) => send(API.addTrtcLog, option);

}
